// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3erNo","notes":"Notes_notes__2sAGB"};